import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setVideoOverlay } from 'state/actions/viewActions';
import get from 'utils/get';
import v from 'vudu';
import { styles as s, breakpoints, colors } from 'stylesheet';
import X from 'components/svgs/X';
import SmallMp4 from 'assets/small.mp4';
import SmallOgg from 'assets/small.ogv';

const localClasses = v({
  videoWrapper: {
    backgroundColor: colors.black,
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 666,
  },
  videoEl: {
    width: '100%',
    height: '100%',
  },
  xIcon: {
    position: 'fixed',
    right: '20px',
    top: '20px',
    zIndex: 1,
    cursor: 'pointer',
  }
});

class VideoOverlay extends Component {

  constructor(props) {
    super(...arguments);
  }

  componentWillReceieveProps(nextProps) {
    if (this.props !== nextProps) {
      if (nextProps.showVideo) {
        this.setState({ isOpen: true });
      }
    }
  }

  render() {

    const { isVisible, actions: { setVideoOverlay } } = this.props;

    if (isVisible) {
      return (
        <div className={localClasses.videoWrapper}>
          <div className={localClasses.xIcon} onClick={() => setVideoOverlay(false)}>
            <X width={20} height={20}/>
          </div>
          <video className={localClasses.videoEl} controls>
            <source src='https://static-assets.frame.io/dreamstation/DreamStation+JL+V06.mp4 ' type='video/mp4' />
          </video>
        </div>
      )
    }
    return null;
  }
};

function mapStateToProps(state) {
  return {
    isVisible: get(state, 'viewState.videoOverlay.isVisible')
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(
      {
        setVideoOverlay,
      },
      dispatch,
    ),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(VideoOverlay);



// WEBPACK FOOTER //
// ./src/components/VideoOverlay.js